function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 13H5c-.6 0-1-.4-1-1s.4-1 1-1h14c.6 0 1 .4 1 1s-.4 1-1 1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20c-.3 0-.5-.1-.7-.3l-7-7c-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0s.4 1 0 1.4L6.4 12l6.3 6.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
});

function SvgIconArrowLeft(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0xOSAxM2gtMTRjLS42IDAtMS0uNC0xLTFzLjQtMSAxLTFoMTRjLjYgMCAxIC40IDEgMXMtLjQgMS0xIDF6Ii8+PHBhdGggZD0ibTEyIDIwYy0uMyAwLS41LS4xLS43LS4zbC03LTdjLS40LS40LS40LTEgMC0xLjRsNy03Yy40LS40IDEtLjQgMS40IDBzLjQgMSAwIDEuNGwtNi4zIDYuMyA2LjMgNi4zYy40LjQuNCAxIDAgMS40LS4yLjItLjQuMy0uNy4zeiIvPjwvc3ZnPg==";
export { SvgIconArrowLeft as ReactComponent };